// Cookie-баннер (152-ФЗ / GDPR): категории necessary и analytics (opt-in).
// Аналитика Umami/Plausible подключается только после согласия.
import { put } from '@/api/client';
import { nativeApp } from '@/lib/native';
import { useGame } from '@/store/game';
import { Button } from '@/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function loadAnalytics(): void {
  const src = import.meta.env.VITE_ANALYTICS_SRC as string | undefined;
  const site = import.meta.env.VITE_ANALYTICS_SITE as string | undefined;
  if (!src || !site || document.getElementById('sk-analytics')) return;
  const s = document.createElement('script');
  s.id = 'sk-analytics';
  s.defer = true;
  s.src = src;
  s.dataset.websiteId = site;
  s.dataset.domain = location.hostname;
  document.head.appendChild(s);
}

export function CookieBanner() {
  const { t } = useTranslation();
  const user = useGame((s) => s.user);
  const [choice, setChoice] = useState(() => localStorage.getItem('sk_cookie'));
  if (choice === 'all') loadAnalytics();
  // В админке баннер не нужен (это не игра, аналитика там не подключается)
  // В Android-приложении cookie нет (вход по токенам), веб-аналитика не подключается
  if (choice || nativeApp || window.location.pathname.startsWith('/admin')) return null;
  const decide = (all: boolean) => {
    localStorage.setItem('sk_cookie', all ? 'all' : 'necessary');
    setChoice(all ? 'all' : 'necessary');
    if (user) void put('/account/settings', { analyticsConsent: all }).catch(() => undefined);
    if (all) loadAnalytics();
  };
  return (
    <div
      role="dialog"
      aria-label="cookies"
      className="fixed inset-x-2 bottom-[calc(76px+env(safe-area-inset-bottom))] z-[56] rounded-2xl border border-gold-600 bg-ink-800 p-3 text-[15px] shadow-2xl md:left-auto md:w-96"
    >
      <p className="mb-2">
        {t('cookie.text')}{' '}
        <Link className="underline" to="/legal/privacy">
          {t('legal.privacy')}
        </Link>
      </p>
      <div className="flex gap-2">
        <Button className="flex-1" onClick={() => decide(true)}>
          {t('cookie.accept')}
        </Button>
        <Button className="flex-1" variant="secondary" onClick={() => decide(false)}>
          {t('cookie.necessary')}
        </Button>
      </div>
    </div>
  );
}
